import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class UniversityBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.UNIVERSITY;
}

export default UniversityBuildingTileEntity;
